// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.c-icon[data-v-7983366c] {\n  margin-right: 0.3rem;\n}\n", ""]);
// Exports
module.exports = exports;
